import C from './constants'

export const setProcessYieldValues = (values) => (
    {
        type: C.SET_PROCESS_YIELD_VALUES,
        payload: values
    }
)
